import React from 'react';
import PropTypes from 'prop-types';

import { LoadablePaint } from '@confluence/loadable';
import { CONTAINER_ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

const LazyExportSpaceRouteComponent = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ExportSpaceRouteV2Component" */
				'./ExportSpaceRouteComponent.tsx'
			)
		).ExportSpaceRouteComponent,
});

export const LazyExportSpaceRoute: {
	({
		params: { spaceKey },
	}: {
		params: {
			spaceKey: any;
		};
	}): React.JSX.Element;
	propTypes: {
		params: PropTypes.Validator<
			NonNullable<
				PropTypes.InferProps<{
					spaceKey: PropTypes.Validator<string>;
				}>
			>
		>;
	};
	NAVIGATION_PARAMS({
		params: { spaceKey },
	}: {
		params: {
			spaceKey: any;
		};
	}): {
		Screen: {
			screenEvent: {
				name: string;
			};
			pageState: {
				spaceKey: any;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: any;
			disableMinWidth: boolean;
		};
	};
} = ({
	params: { spaceKey },
}: {
	params: {
		spaceKey: any;
	};
}): React.JSX.Element => {
	return <LazyExportSpaceRouteComponent spaceKey={spaceKey} />;
};

LazyExportSpaceRoute.propTypes = {
	params: PropTypes.shape({
		spaceKey: PropTypes.string.isRequired,
	}).isRequired,
};

LazyExportSpaceRoute.NAVIGATION_PARAMS = ({
	params: { spaceKey },
}: {
	params: {
		spaceKey: any;
	};
}): {
	Screen: {
		screenEvent: {
			name: string;
		};
		pageState: {
			spaceKey: any;
		};
	};
	MainLayout: {
		navView: string;
		spaceKey: any;
		disableMinWidth: boolean;
	};
} => ({
	Screen: {
		screenEvent: { name: 'ExportSpaceScreen' },
		pageState: { spaceKey },
	},
	MainLayout: {
		navView: CONTAINER_ADMIN_HOME_ID,
		spaceKey,
		disableMinWidth: true,
	},
});
